// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CakeIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29 14a3 3 0 0 0-3-3h-9V9.875a4.007 4.007 0 0 0 3-3.874C20 2.5 16.695.26 16.555.168a1 1 0 0 0-1.11 0C15.305.262 12 2.501 12 6.001a4.007 4.007 0 0 0 3 3.874V11H6a3 3 0 0 0-3 3v2.917a5.105 5.105 0 0 0 1 3.03V25a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-5.053a5.105 5.105 0 0 0 1-3.03V14ZM14 6c0-1.696 1.25-3.057 2-3.723.75.666 2 2.027 2 3.724a2 2 0 0 1-4 0Zm-9 8a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v2.917c0 1.656-1.308 3.038-2.916 3.082A3 3 0 0 1 21 17a1 1 0 0 0-2 0 3 3 0 0 1-6 0 1 1 0 1 0-2 0 3.002 3.002 0 0 1-3.085 3C6.307 19.955 5 18.573 5 16.917V14Zm20 12H7a1 1 0 0 1-1-1v-3.43a4.847 4.847 0 0 0 1.86.43 4.96 4.96 0 0 0 3.625-1.413c.186-.182.359-.378.515-.587a4.999 4.999 0 0 0 8 0c.156.208.329.403.516.584A4.96 4.96 0 0 0 24 22h.142A4.846 4.846 0 0 0 26 21.57V25a1 1 0 0 1-1 1Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
